import React from 'react';
import styled from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectCarBlogData } from '@/store/reducers/detailed-car';
import PostReviewCard from '@/components/PostReviewCard';

function BlogBanner() {
  const carBlogData = useTypedSelector(selectCarBlogData);

  if (!carBlogData || carBlogData.length === 0) {
    return null;
  }

  const post = carBlogData[0];

  return (
    <Component>
      <PostReviewCard
        image={post.image}
        title={post.title ?? ''}
        description={post.excerpt ?? ''}
        buttonLink={post.url ?? ''}
      />
    </Component>
  );
}

export default BlogBanner;

const Component = styled.div`
  margin-top: 40px;
`;
